module.exports = __webpack_public_path__ + "static/index/img/baikal-504.c66d8503.jpg";